import {Component, DestroyRef, inject, Inject, OnInit} from '@angular/core';
import {AttributeGroupService} from '@emm/core/services/attribute-group.service';
import {AttributeGroup} from '@emm/core/models/attribute-group.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup} from '@angular/forms';
import {RegexConstants} from '@emm/core/util/regex.constants';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';


@Component({
    selector: 'emm-add-attribute-group-dialog',
    templateUrl: './add-attribute-group-dialog.component.html',
    styleUrls: ['./add-attribute-group-dialog.component.scss'],
    standalone: false
})
export class AddAttributeGroupDialogComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    form: FormGroup;
    spaceValidatorPattern = RegexConstants.STARTING_SPACE_VALIDATIOR_PATTERN;
    isReadOnly = this.authFacade.isReadOnly$;

    constructor(
      public attributeGroupService: AttributeGroupService,
      private authFacade: AuthFacadeService,
      public dialogRef: MatDialogRef<AddAttributeGroupDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.buildForm();
    }

    ngOnInit(): void {
        this.dialogRef.updatePosition({ top: '100px' });
    }



    onNoClick(): void {
        this.dialogRef.close();
    }


    closeAfterSubmit(): void {
        const result = {
            id: this.form.controls.id.value,
            name: this.form.controls.name.value,
            description: this.form.controls.description.value
        } as AttributeGroup;
        this.dialogRef.close(result);
    }



    buildForm(): void {
        this.form = new FormGroup({
            id: new FormControl(''),
            name: new FormControl(''),
            description: new FormControl(''),
        });
    }


    findGroupExists(): void {
        if (this.form.controls['id'].valid) {
            this.attributeGroupService
                .getAttributeGroups()
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe((res) => {
                    if (res != null) {
                        if (res.find((attributeGroup: AttributeGroup) => attributeGroup.id === this.form.controls['id'].value)) {
                            this.form.controls['id'].setErrors({idExists: true});
                        }
                    }
                });
        }
    }


    findNameExists(): void {
        this.attributeGroupService
            .getAttributeGroups()
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe((res) => {
                if (res != null) {
                    if (res.find((attributeGroup: AttributeGroup) => attributeGroup.name === this.form.controls['name'].value)) {
                        this.form.controls['name'].setErrors({ nameExists: true });
                    }
                }
            });
    }



    OnSubmit(): void {
        if (this.form.valid) {
            this.closeAfterSubmit();
        }
    }
}
